import { commonService } from './commonService';

export const developmentTeams = {
  ...commonService,
  name: 'Development Teams',
  serviceType: [
    'Prototyping',
    'MVP',
    'Product-Market Fit',
    'Scale & Maturity Team',
  ],
  description:
    'Boldare’s digital product development teams will help you conceptualize your idea, design and build the first version of your product, find a product-market fit, and develop a scalable web product.',
};
